import { Card } from '@/components/ui/card';
import { cn } from 'src/lib/utils';

type Props = {
  items: React.ReactNode[];
  classes?: {
    item?: string;
  };
};

const SetupSteps = ({ items, classes }: Props) => {
  return (
    <ul className="space-y-6">
      {items.map((item, index) => (
        <li key={index}>
          <Card className={cn('p-6 flex items-center gap-3 bg-muted', classes?.item)}>
            <span className="font-semibold size-6 text-foreground text-xs bg-primary rounded-full flex items-center justify-center shrink-0">
              {index + 1}
            </span>
            <div className="grow text-sm">{item}</div>
          </Card>
        </li>
      ))}
    </ul>
  );
};

export default SetupSteps;
